import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, toDisplayString as _toDisplayString, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-07df167e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "df mt-15 search-wrapper" }
const _hoisted_3 = { class: "w-100" }
const _hoisted_4 = {
  key: 0,
  class: "icon icon-back"
}
const _hoisted_5 = { class: "df jc-right" }
const _hoisted_6 = {
  key: 1,
  for: "mediaInput",
  class: "df"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-plus" }, null, -1))
const _hoisted_8 = { key: 3 }
const _hoisted_9 = {
  key: 1,
  class: "d-wrapper"
}
const _hoisted_10 = { class: "d-container" }
const _hoisted_11 = { class: "d-aside" }
const _hoisted_12 = { class: "d-aside__main-menu" }
const _hoisted_13 = { class: "d-aside__nav" }
const _hoisted_14 = { class: "d-aside__add-menu d-add-menu" }
const _hoisted_15 = {
  key: 0,
  class: "d-add-menu__btn"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-add-menu__icon icon icon-plus" }, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-add-menu__title" }, "New...", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "d-add-menu__caret icon icon-caret" }, null, -1))
const _hoisted_19 = [
  _hoisted_16,
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = {
  key: 1,
  for: "mediaInput"
}
const _hoisted_21 = { class: "d-add-menu__btn-body" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-add-menu__icon icon icon-plus" }, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-add-menu__title" }, "New...", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "d-add-menu__caret icon icon-caret" }, null, -1))
const _hoisted_25 = {
  key: 0,
  class: "d-add-menu__btn"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-add-menu__icon icon icon-plus" }, null, -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-add-menu__title" }, "New...", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "d-add-menu__caret icon icon-caret" }, null, -1))
const _hoisted_29 = [
  _hoisted_26,
  _hoisted_27,
  _hoisted_28
]
const _hoisted_30 = { class: "d-add-menu__body" }
const _hoisted_31 = { class: "d-aside-menu" }
const _hoisted_32 = { class: "d-aside-menu__link-text" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-caret" }, null, -1))
const _hoisted_34 = { class: "d-aside-menu__link-text" }
const _hoisted_35 = { class: "d-aside-menu__link-text" }
const _hoisted_36 = { class: "d-aside-menu__link-text" }
const _hoisted_37 = { class: "d-aside-menu__link-text" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-caret" }, null, -1))
const _hoisted_39 = { class: "d-aside-menu__link-text" }
const _hoisted_40 = { class: "d-aside-menu__link-text" }
const _hoisted_41 = { class: "d-aside-menu__link-text" }
const _hoisted_42 = { key: 0 }
const _hoisted_43 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_drive_shared_bar = _resolveComponent("drive-shared-bar")!
  const _component_app_search = _resolveComponent("app-search")!
  const _component_app_header = _resolveComponent("app-header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_app_add_button = _resolveComponent("app-add-button")!
  const _component_app_navigation = _resolveComponent("app-navigation")!
  const _component_app_photo_view = _resolveComponent("app-photo-view")!
  const _component_app_file_view = _resolveComponent("app-file-view")!
  const _component_app_media_view = _resolveComponent("app-media-view")!
  const _component_app_mixed_selector = _resolveComponent("app-mixed-selector")!
  const _component_app_photo_selector = _resolveComponent("app-photo-selector")!
  const _component_app_case_selector = _resolveComponent("app-case-selector")!
  const _component_share_pop_up = _resolveComponent("share-pop-up")!
  const _component_case_settings_pop_up = _resolveComponent("case-settings-pop-up")!
  const _component_app_reorder_photo = _resolveComponent("app-reorder-photo")!
  const _component_move_to_pop_up = _resolveComponent("move-to-pop-up")!
  const _component_app_question_pop_up = _resolveComponent("app-question-pop-up")!
  const _component_drive_delete_confirm = _resolveComponent("drive-delete-confirm")!
  const _component_app_loader = _resolveComponent("app-loader")!
  const _component_app_progress = _resolveComponent("app-progress")!
  const _component_app_skeleton_case_edit = _resolveComponent("app-skeleton-case-edit")!
  const _component_desktop_header = _resolveComponent("desktop-header")!
  const _component_drive_aside_main_menu = _resolveComponent("drive-aside-main-menu")!
  const _component_drive_upload_all_menu = _resolveComponent("drive-upload-all-menu")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_drive_media_view = _resolveComponent("drive-media-view")!
  const _component_app_create_folder_pop_up = _resolveComponent("app-create-folder-pop-up")!

  return (_ctx.mainStore.isMobile)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.currentPage !== 'CASE_EDIT' && _ctx.currentPage !=='CASE_CREATE')
          ? (_openBlock(), _createBlock(_component_app_header, {
              key: 0,
              customTitle: _ctx.customTitle
            }, _createSlots({
              "top-left": _withCtx(() => [
                _createElementVNode("a", {
                  href: "javascript:void(0);",
                  onClick: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.backAction && _ctx.backAction(...args)), ["prevent"])),
                  class: "back-link"
                }, [
                  (_ctx.isBackArrow)
                    ? (_openBlock(), _createElementBlock("i", _hoisted_4))
                    : _createCommentVNode("", true)
                ])
              ]),
              "top-right": _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  (_ctx.topRightText)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        onClick: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.doneAction && _ctx.doneAction(...args)), ["prevent"])),
                        class: _normalizeClass([{ disabled: _ctx.isDoneDisabled }, "link"]),
                        href: "javascript:void(0);"
                      }, _toDisplayString(_ctx.topRightText), 3))
                    : _createCommentVNode("", true),
                  (_ctx.actionBar.showBar)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: _normalizeClass(["icon-box", { 'flex-end': _ctx.isNetwork }])
                      }, [
                        (_ctx.actionBar.showShare)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: "icon icon-share",
                              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.openSharePopUp(_ctx.driveStore.currentCase!, _ctx.SHARE_TYPES.CASE)))
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.actionBar.showDots)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 1,
                              class: "icon icon-dots",
                              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.isCaseSettingsPopUp = true))
                            }))
                          : _createCommentVNode("", true)
                      ], 2))
                    : _createCommentVNode("", true),
                  (_ctx.isSelector)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 2,
                        href: "javascript:void(0);",
                        onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.openSelector && _ctx.openSelector(...args))),
                        class: "link select"
                      }, _toDisplayString(_ctx.$localize('drive.selector')), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 2
            }, [
              (!_ctx.hideHeaderSearch)
                ? {
                    name: "bottom",
                    fn: _withCtx(() => [
                      (!_ctx.isNetwork)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "folder-labels",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openSharePopUp(_ctx.driveStore.currentFolder!, _ctx.SHARE_TYPES.FOLDER)))
                          }, [
                            _createVNode(_component_drive_shared_bar, {
                              onOnVisitChat: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
                            })
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                          _createVNode(_component_app_search, {
                            modelValue: _ctx.driveStore.search,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.driveStore.search) = $event)),
                            onClear: _cache[3] || (_cache[3] = ($event: any) => (_ctx.driveStore.search = '')),
                            placeholder: _ctx.$localize('drive.placeholder.search')
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        (_ctx.currentPage === _ctx.NAVIGATION_PAGES.DRIVE_CASES
                 || _ctx.currentPage === _ctx.NAVIGATION_PAGES.NETWORK_CASES
                 || _ctx.currentPage === _ctx.NAVIGATION_PAGES.PUBLIC_CASES
                 || _ctx.currentPage === _ctx.NAVIGATION_PAGES.MY_PUBLIC_CASES)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: _normalizeClass(["ml-16 icon", _ctx.driveStore.isGridCasesView ? 'icon-tiles-2' : 'icon-list-view']),
                              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.driveStore.isGridCasesView = !_ctx.driveStore.isGridCasesView))
                            }, null, 2))
                          : _createCommentVNode("", true),
                        (_ctx.currentPage === _ctx.NAVIGATION_PAGES.DRIVE_FOLDER
               || _ctx.currentPage === _ctx.NAVIGATION_PAGES.DRIVE_FILES
               || _ctx.currentPage === _ctx.NAVIGATION_PAGES.NETWORK_FILES)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 1,
                              class: _normalizeClass(["ml-16 icon", _ctx.driveStore.isGridFolderView ? 'icon-tiles-2' : 'icon-list-view']),
                              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.driveStore.isGridFolderView = !_ctx.driveStore.isGridFolderView))
                            }, null, 2))
                          : _createCommentVNode("", true),
                        (_ctx.currentPage === _ctx.NAVIGATION_PAGES.DRIVE_PHOTOS
               || _ctx.currentPage === _ctx.NAVIGATION_PAGES.NETWORK_PHOTOS)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 2,
                              class: _normalizeClass(["ml-16 icon", {
              'icon-tiles-2': _ctx.driveStore.photoViewLayout === _ctx.PHOTO_VIEW_LAYOUT.GRID_LABEL,
              'icon-tiles': _ctx.driveStore.photoViewLayout === _ctx.PHOTO_VIEW_LAYOUT.GRID,
              'icon-list-view': _ctx.driveStore.photoViewLayout === _ctx.PHOTO_VIEW_LAYOUT.LIST,
            }]),
                              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.driveStore.switchPhotoView && _ctx.driveStore.switchPhotoView(...args)))
                            }, null, 2))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  }
                : undefined
            ]), 1032, ["customTitle"]))
          : _createCommentVNode("", true),
        _createVNode(_component_router_view, {
          onOpenShare: _cache[12] || (_cache[12] = ($event: any) => (_ctx.openSharePopUp(_ctx.driveStore.currentCase!, _ctx.SHARE_TYPES.CASE))),
          "show-skeleton": _ctx.isCaseCopying
        }, null, 8, ["show-skeleton"]),
        (!_ctx.hideAppButton)
          ? (_openBlock(), _createBlock(_component_app_add_button, {
              key: 1,
              class: _normalizeClass({ 'bottom': _ctx.hideBottomNav })
            }, {
              default: _withCtx(() => [
                (!_ctx.isAddMedia)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.onAddButtonClick && _ctx.onAddButtonClick(...args))),
                      class: "icon icon-plus"
                    }))
                  : (_openBlock(), _createElementBlock("label", _hoisted_6, [
                      _hoisted_7,
                      _createElementVNode("input", {
                        onInput: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.uploadMedia && _ctx.uploadMedia(...args))),
                        id: "mediaInput",
                        ref: "fileInput",
                        class: "hide",
                        type: "file",
                        accept: "image/*, video/*",
                        multiple: ""
                      }, null, 544)
                    ]))
              ]),
              _: 1
            }, 8, ["class"]))
          : _createCommentVNode("", true),
        (!_ctx.hideBottomNav)
          ? (_openBlock(), _createBlock(_component_app_navigation, {
              key: 2,
              "navigation-data": _ctx.navigationData
            }, null, 8, ["navigation-data"]))
          : _createCommentVNode("", true),
        false
          ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
              (_ctx.driveStore.fullscreenPhoto)
                ? (_openBlock(), _createBlock(_component_app_photo_view, {
                    key: 0,
                    onSwitchPhoto: _cache[15] || (_cache[15] = ($event: any) => (_ctx.onSwitchPhoto($event))),
                    onClose: _ctx.closeFullScreen
                  }, null, 8, ["onClose"]))
                : _createCommentVNode("", true),
              (_ctx.driveStore.fullscreenFile)
                ? (_openBlock(), _createBlock(_component_app_file_view, {
                    key: 1,
                    onClose: _ctx.closeFullScreen
                  }, null, 8, ["onClose"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.driveStore.appPhotoViewMedia)
          ? (_openBlock(), _createBlock(_component_app_media_view, {
              key: 4,
              onOnClose: _ctx.closeFullScreen
            }, null, 8, ["onOnClose"]))
          : _createCommentVNode("", true),
        (_ctx.driveStore.isMixedSelector)
          ? (_openBlock(), _createBlock(_component_app_mixed_selector, {
              key: 5,
              onClose: _cache[16] || (_cache[16] = ($event: any) => (_ctx.driveStore.isMixedSelector = false))
            }))
          : _createCommentVNode("", true),
        (_ctx.driveStore.isPhotoSelector)
          ? (_openBlock(), _createBlock(_component_app_photo_selector, {
              key: 6,
              onClose: _cache[17] || (_cache[17] = ($event: any) => (_ctx.driveStore.isPhotoSelector = false))
            }))
          : _createCommentVNode("", true),
        (_ctx.driveStore.isCaseSelector)
          ? (_openBlock(), _createBlock(_component_app_case_selector, {
              key: 7,
              onClose: _cache[18] || (_cache[18] = ($event: any) => (_ctx.driveStore.isCaseSelector = false))
            }))
          : _createCommentVNode("", true),
        (_ctx.sharedPopUp.item)
          ? (_openBlock(), _createBlock(_component_share_pop_up, {
              key: 8,
              item: _ctx.sharedPopUp.item,
              "item-type": _ctx.sharedPopUp.type!,
              onHide: _ctx.closeSharePopUp,
              onSetItemShared: _ctx.setItemShared,
              onSetSharedLabels: _ctx.setSharedLabels,
              onOnShareByMessage: _ctx.removeSharedItemFromStore
            }, null, 8, ["item", "item-type", "onHide", "onSetItemShared", "onSetSharedLabels", "onOnShareByMessage"]))
          : _createCommentVNode("", true),
        (_ctx.isCaseSettingsPopUp)
          ? (_openBlock(), _createBlock(_component_case_settings_pop_up, {
              key: 9,
              "i-case": _ctx.driveStore.currentCase!,
              onClose: _cache[19] || (_cache[19] = ($event: any) => (_ctx.isCaseSettingsPopUp = false)),
              onOpenMovePopUp: _ctx.openMovePopUp,
              onDeleteCase: _ctx.openQuestionPopUp,
              onSaveCaseAsCopy: _ctx.saveCaseAsCopy,
              onRemoveSharing: _ctx.removeCaseFromSharing,
              onOpenReorderPhoto: _ctx.openReorderPhoto
            }, null, 8, ["i-case", "onOpenMovePopUp", "onDeleteCase", "onSaveCaseAsCopy", "onRemoveSharing", "onOpenReorderPhoto"]))
          : _createCommentVNode("", true),
        (_ctx.reorderPhotoView)
          ? (_openBlock(), _createBlock(_component_app_reorder_photo, {
              key: 10,
              onClose: _cache[20] || (_cache[20] = ($event: any) => (_ctx.reorderPhotoView = false))
            }))
          : _createCommentVNode("", true),
        (_ctx.isMoveToCasePopUp)
          ? (_openBlock(), _createBlock(_component_move_to_pop_up, {
              key: 11,
              item: _ctx.driveStore.currentCase!,
              "item-type": _ctx.SHARE_TYPES.CASE,
              onClose: _cache[21] || (_cache[21] = ($event: any) => (_ctx.isMoveToCasePopUp = false)),
              onUpdateLocation: _ctx.updateLocation
            }, null, 8, ["item", "item-type", "onUpdateLocation"]))
          : _createCommentVNode("", true),
        (_ctx.isQuestionPopUp)
          ? (_openBlock(), _createBlock(_component_app_question_pop_up, {
              key: 12,
              onClose: _cache[22] || (_cache[22] = ($event: any) => (_ctx.isQuestionPopUp = false)),
              onDelete: _ctx.deleteCase
            }, null, 8, ["onDelete"]))
          : _createCommentVNode("", true),
        (_ctx.isDeleteConfirm)
          ? (_openBlock(), _createBlock(_component_drive_delete_confirm, {
              key: 13,
              onDone: _ctx.deleteCase,
              onCancel: _cache[23] || (_cache[23] = ($event: any) => (_ctx.isDeleteConfirm = false))
            }, null, 8, ["onDone"]))
          : _createCommentVNode("", true),
        (!!_ctx.isSaving)
          ? (_openBlock(), _createBlock(_component_app_loader, {
              key: 14,
              message: _ctx.loaderText
            }, null, 8, ["message"]))
          : _createCommentVNode("", true),
        (_ctx.isProgress)
          ? (_openBlock(), _createBlock(_component_app_progress, {
              key: 15,
              message: "Saving Your Case...",
              percent: _ctx.percent
            }, null, 8, ["percent"]))
          : _createCommentVNode("", true),
        (_ctx.isCaseCreating)
          ? (_openBlock(), _createBlock(_component_app_skeleton_case_edit, { key: 16 }))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_9, [
        _createVNode(_component_desktop_header),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("aside", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_drive_aside_main_menu)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_Transition, { name: "fade" }, {
                  default: _withCtx(() => [
                    (!_ctx.isAddMenuDesktop)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          (!_ctx.isAddMedia)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.onAddButtonClickDesktop && _ctx.onAddButtonClickDesktop(...args))),
                                class: "d-add-menu__btn-body"
                              }, _hoisted_19))
                            : (_openBlock(), _createElementBlock("label", _hoisted_20, [
                                _createElementVNode("div", _hoisted_21, [
                                  _hoisted_22,
                                  _createElementVNode("input", {
                                    onInput: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.uploadMedia && _ctx.uploadMedia(...args))),
                                    id: "mediaInput",
                                    ref: "fileInput",
                                    class: "hide",
                                    type: "file",
                                    multiple: ""
                                  }, null, 544),
                                  _hoisted_23,
                                  _hoisted_24
                                ])
                              ]))
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_Transition, { name: "fade" }, {
                  default: _withCtx(() => [
                    (_ctx.isCaseFolder)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                          (_ctx.isCaseFolder)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.addCase && _ctx.addCase(...args))),
                                class: "d-add-menu__btn-body"
                              }, _hoisted_29))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_30, [
                  _createVNode(_component_drive_upload_all_menu, {
                    class: "d-add-menu__body-menu",
                    show: _ctx.isAddMenuDesktop,
                    onClose: _cache[27] || (_cache[27] = ($event: any) => (_ctx.isAddMenuDesktop = !_ctx.isAddMenuDesktop))
                  }, null, 8, ["show"])
                ])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createVNode(_component_el_menu, {
                  "default-openeds": ['1', '2'],
                  class: "el-menu-vertical"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_menu_item, { index: "1-1" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_link, {
                          class: "d-aside-menu__link",
                          to: "/drive"
                        }, {
                          default: _withCtx(({ isExactActive }) => [
                            _createElementVNode("i", {
                              class: _normalizeClass(["d-aside-menu__link-icon icon", isExactActive ? 'icon-folder-logo-active' :  'icon-folder-logo'])
                            }, null, 2),
                            _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.$localize('drive.header.title')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_sub_menu, { index: "1" }, {
                      title: _withCtx(() => [
                        _hoisted_33
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_el_menu_item, { index: "1-2" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_router_link, {
                              class: _normalizeClass(["d-aside-menu__link d-aside-menu__sub-link", _ctx.isUserCasesFolder ? 'router-link-exact-active' : '']),
                              to: "/drive/my/cases"
                            }, {
                              default: _withCtx(({ isActive }) => [
                                _createElementVNode("i", {
                                  class: _normalizeClass(["d-aside-menu__link-icon icon", isActive || _ctx.isUserCasesFolder ? 'icon-tablet-active' : 'icon-tablet'])
                                }, null, 2),
                                _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.$localize('drive.section.cases.title')), 1)
                              ]),
                              _: 1
                            }, 8, ["class"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_menu_item, { index: "1-3" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_router_link, {
                              class: "d-aside-menu__link d-aside-menu__sub-link",
                              to: "/drive/my/photos"
                            }, {
                              default: _withCtx(({ isActive }) => [
                                _createElementVNode("i", {
                                  class: _normalizeClass(["d-aside-menu__link-icon icon", isActive ? 'icon-image-active' :  'icon-image'])
                                }, null, 2),
                                _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.$localize('drive.section.photo.title')), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_menu_item, { index: "1-4" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_router_link, {
                              class: "d-aside-menu__link d-aside-menu__sub-link",
                              to: "/drive/my/files"
                            }, {
                              default: _withCtx(({ isActive }) => [
                                _createElementVNode("i", {
                                  class: _normalizeClass(["d-aside-menu__link-icon icon", isActive ? 'icon-folder-active' :  'icon-folder'])
                                }, null, 2),
                                _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.$localize('drive.view.case.files.tab')), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_menu_item, { index: "2-1" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_link, {
                          class: "d-aside-menu__link",
                          to: "/drive/network"
                        }, {
                          default: _withCtx(({ isExactActive }) => [
                            _createElementVNode("i", {
                              class: _normalizeClass(["d-aside-menu__link-icon icon", isExactActive ? 'icon-folder-active' :  'icon-folder'])
                            }, null, 2),
                            _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.$localize('drive.network.desktop.title')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_sub_menu, { index: "2" }, {
                      title: _withCtx(() => [
                        _hoisted_38
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_el_menu_item, { index: "2-2" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_router_link, {
                              class: "d-aside-menu__link d-aside-menu__sub-link",
                              to: "/drive/network/cases"
                            }, {
                              default: _withCtx(({ isActive }) => [
                                _createElementVNode("i", {
                                  class: _normalizeClass(["d-aside-menu__link-icon icon", isActive ? 'icon-tablet-active' :  'icon-tablet'])
                                }, null, 2),
                                _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.$localize('drive.section.cases.title')), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_menu_item, { index: "2-3" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_router_link, {
                              class: "d-aside-menu__link d-aside-menu__sub-link",
                              to: "/drive/network/photos"
                            }, {
                              default: _withCtx(({ isActive }) => [
                                _createElementVNode("i", {
                                  class: _normalizeClass(["d-aside-menu__link-icon icon", isActive ? 'icon-image-active' :  'icon-image'])
                                }, null, 2),
                                _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.$localize('drive.section.photo.title')), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_menu_item, { index: "2-4" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_router_link, {
                              class: "d-aside-menu__link d-aside-menu__sub-link",
                              to: "/drive/network/files"
                            }, {
                              default: _withCtx(({ isActive }) => [
                                _createElementVNode("i", {
                                  class: _normalizeClass(["d-aside-menu__link-icon icon", isActive ? 'icon-folder-active' :  'icon-folder'])
                                }, null, 2),
                                _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.$localize('drive.view.case.files.tab')), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("main", {
            class: _normalizeClass(!_ctx.isCaseView
        && _ctx.currentPage !== _ctx.NAVIGATION_PAGES.CASE_EDIT
        && _ctx.currentPage !== _ctx.NAVIGATION_PAGES.CASE_CREATE
        && !_ctx.route.meta?.caseNetworkView ? 'd-main' : 'd-main-caseview')
          }, [
            (_ctx.isCaseView)
              ? (_openBlock(), _createBlock(_component_router_view, {
                  key: 0,
                  "show-skeleton": _ctx.isCaseCopying,
                  onDeleteCase: _ctx.openQuestionPopUp,
                  onSaveCaseAsCopy: _ctx.saveCaseAsCopy,
                  onOpenShare: _cache[28] || (_cache[28] = ($event: any) => (_ctx.openSharePopUp(_ctx.driveStore.currentCase!, _ctx.SHARE_TYPES.CASE)))
                }, null, 8, ["show-skeleton", "onDeleteCase", "onSaveCaseAsCopy"]))
              : (_openBlock(), _createBlock(_component_router_view, {
                  key: 1,
                  onOpenShare: _cache[29] || (_cache[29] = ($event: any) => (_ctx.openSharePopUp(_ctx.driveStore.currentCase!, _ctx.SHARE_TYPES.CASE)))
                }))
          ], 2)
        ]),
        false
          ? (_openBlock(), _createElementBlock("span", _hoisted_42, [
              (_ctx.driveStore.fullscreenPhoto)
                ? (_openBlock(), _createBlock(_component_app_photo_view, {
                    key: 0,
                    onSwitchPhoto: _cache[30] || (_cache[30] = ($event: any) => (_ctx.onSwitchPhoto($event))),
                    onClose: _ctx.closeFullScreen
                  }, null, 8, ["onClose"]))
                : _createCommentVNode("", true),
              (_ctx.driveStore.fullscreenFile)
                ? (_openBlock(), _createBlock(_component_app_file_view, {
                    key: 1,
                    onClose: _ctx.closeFullScreen
                  }, null, 8, ["onClose"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        true
          ? (_openBlock(), _createElementBlock("span", _hoisted_43, [
              (_ctx.driveStore.appPhotoViewMedia)
                ? (_openBlock(), _createBlock(_component_drive_media_view, {
                    key: 0,
                    onOnClose: _ctx.closeFullScreen
                  }, null, 8, ["onOnClose"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.driveStore.isMixedSelector)
          ? (_openBlock(), _createBlock(_component_app_mixed_selector, {
              key: 2,
              onClose: _cache[31] || (_cache[31] = ($event: any) => (_ctx.driveStore.isMixedSelector = false))
            }))
          : _createCommentVNode("", true),
        (_ctx.driveStore.isPhotoSelector)
          ? (_openBlock(), _createBlock(_component_app_photo_selector, {
              key: 3,
              onClose: _cache[32] || (_cache[32] = ($event: any) => (_ctx.driveStore.isPhotoSelector = false))
            }))
          : _createCommentVNode("", true),
        (_ctx.driveStore.isCaseSelector)
          ? (_openBlock(), _createBlock(_component_app_case_selector, {
              key: 4,
              onClose: _cache[33] || (_cache[33] = ($event: any) => (_ctx.driveStore.isCaseSelector = false))
            }))
          : _createCommentVNode("", true),
        (_ctx.sharedPopUp.item)
          ? (_openBlock(), _createBlock(_component_share_pop_up, {
              key: 5,
              item: _ctx.sharedPopUp.item,
              "item-type": _ctx.sharedPopUp.type!,
              onHide: _ctx.closeSharePopUp,
              onSetItemShared: _ctx.setItemShared,
              onSetSharedLabels: _ctx.setSharedLabels
            }, null, 8, ["item", "item-type", "onHide", "onSetItemShared", "onSetSharedLabels"]))
          : _createCommentVNode("", true),
        (_ctx.isCaseSettingsPopUp)
          ? (_openBlock(), _createBlock(_component_case_settings_pop_up, {
              key: 6,
              "i-case": _ctx.driveStore.currentCase!,
              onClose: _cache[34] || (_cache[34] = ($event: any) => (_ctx.isCaseSettingsPopUp = false)),
              onOpenMovePopUp: _ctx.openMovePopUp
            }, null, 8, ["i-case", "onOpenMovePopUp"]))
          : _createCommentVNode("", true),
        (_ctx.isMoveToCasePopUp)
          ? (_openBlock(), _createBlock(_component_move_to_pop_up, {
              key: 7,
              item: _ctx.driveStore.currentCase!,
              "item-type": _ctx.SHARE_TYPES.CASE,
              onClose: _cache[35] || (_cache[35] = ($event: any) => (_ctx.isMoveToCasePopUp = false)),
              onUpdateLocation: _ctx.updateLocation
            }, null, 8, ["item", "item-type", "onUpdateLocation"]))
          : _createCommentVNode("", true),
        (_ctx.isQuestionPopUp)
          ? (_openBlock(), _createBlock(_component_app_question_pop_up, {
              key: 8,
              onClose: _cache[36] || (_cache[36] = ($event: any) => (_ctx.isQuestionPopUp = false)),
              onDelete: _ctx.deleteCase
            }, null, 8, ["onDelete"]))
          : _createCommentVNode("", true),
        (!!_ctx.isSaving)
          ? (_openBlock(), _createBlock(_component_app_loader, {
              key: 9,
              message: _ctx.loaderText
            }, null, 8, ["message"]))
          : _createCommentVNode("", true),
        (_ctx.isProgress)
          ? (_openBlock(), _createBlock(_component_app_progress, {
              key: 10,
              message: "Saving Your Case...",
              percent: _ctx.percent
            }, null, 8, ["percent"]))
          : _createCommentVNode("", true),
        (_ctx.isCaseCreating)
          ? (_openBlock(), _createBlock(_component_app_skeleton_case_edit, {
              key: 11,
              title: _ctx.driveStore.bufferCurrentCaseTitle
            }, null, 8, ["title"]))
          : _createCommentVNode("", true),
        (_ctx.mainStore.createFolderPopUp)
          ? (_openBlock(), _createBlock(_component_app_create_folder_pop_up, { key: 12 }))
          : _createCommentVNode("", true)
      ]))
}